<template>
    <!-- Inspection List -->
    <div
        id="inspection-list"
        class="col-sm-12"
    >
        <div
            class="data-list-item add"
            @click.stop="$emit('add')"
        >
            <div class="item-img-cont add-title">
                <i class="fa fa-plus"/>
            </div>
            <div class="item-text-cont">
                <span class="item-title-add">{{ $t('common.add_new') }}</span>
                <font-awesome-icon
                    icon="clipboard-check"
                    class="card-body-icon"
                />
            </div>
        </div>
        <Transition name="fade">
            <div v-if="results.length > 0" class="col-sm-12 pb-2 mt-3 result-table">
                <vue3-datatable
                    ref="resultTable"
                    :rows="results"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    height="52em"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    sort-column="name"
                    sort-direction="asc"
                    @row-click="emitEdit"
                >
                    <template #empty>
                        <div class="text-center my-2">
                            {{ $t('area_report.no_results') }}
                        </div>
                    </template>
                    <template #type="row">
                        {{  getInspectionType(row.value.type) }}
                    </template>
                    <template #frequency="row">
                        {{  getInspectionFreq(row.value.frequency) }}
                    </template>
                    <template #actions="row">
                        <span :title="$t('common.copy')" class="nopads" @click.stop="$emit('copy', row.value)">
                            <font-awesome-icon icon="copy" class="row-icon" />
                        </span>
                    </template>
                </vue3-datatable>
            </div>
        </Transition>
    </div>
</template>

<script>
import {vehicleHelper} from '../mixins/VehicleMixin'
import Vue3Datatable from '@bhplugin/vue3-datatable'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'


export default {
    name: 'InspectionList',
    mixins: [vehicleHelper],
    components: {Vue3Datatable, FontAwesomeIcon},
    data()  {
        return {
            fields: [
                {field: 'name', title: this.$t('inspectable_editor.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'type', title: this.$t('inspection_editor.inspection_type'), sort: false, headerClass: 'routa-table-header'},
                {field: 'frequency', title: this.$t('inspection_editor.inspection_frequency'), sort: false, headerClass: 'routa-table-header'},
                {field: 'actions', title: '', sort: false, headerClass: 'routa-table-header'}
            ]
        }
    },
    props: {
        results: {
            type: Array,
            default: null
        }
    },
    methods: {
        emitEdit(item) {
            this.$emit('edit', item)
        },
        getInspectionType: function (type) {
            switch (type) {
                case 1:
                    return this.$t('inspection_template.type.vehicle')
                case 2:
                case 3:
                    return this.$t('inspection_template.type.work')
                case 4:
                    return this.$t('inspection_template.type.company')
                case 5:
                case 7:
                    return this.$t('inspection_template.type.bridge')
                case 6:
                    return this.$t('inspection_template.type.culvert')
                case 8:
                    return this.$t('inspection_template.type.user')
            }
        },
        getInspectionFreq: function (freq) {
            switch (freq) {
                case 1:
                    return this.$t('inspection_template.frequency.weekly')
                case 2:
                    return this.$t('inspection_template.frequency.monthly')
                case 3:
                    return this.$t('inspection_template.frequency.annually')
                case 4:
                    return this.$t('inspection_template.frequency.deployment')
                case 5:
                    return this.$t('inspection_template.frequency.daily')
                case 6:
                    return this.$t('inspection_template.frequency.other')
                case 7:
                    return this.$t('inspection_template.frequency.once')
            }
        }
    }
}
</script>
